"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.webEnvConfig = void 0;
var _configHelper = require("../../helpers/configHelper");
var _MainCacheManager = _interopRequireDefault(require("./MainCacheManager"));
const webEnvConfig = () => {
  let WEBSITE_URL = null;
  let CMS_ONBOARDING_API = null;
  let HP_API_END_POINT = null;
  let API_END_POINT = null;
  let NPS_API_END_POINT = null;
  let ELASTIC_BASE_URL_V2 = null;
  let GOOGLE_GEOCODE_API_URL = null;
  let MAP_API_KEY = null;
  let USER_AGENT = null;
  let SEARCH_SERVICE_BASE_URL = null;
  let SEARCH_SERVICE_AUTOSUGGEST_BASE_URL = null;
  let CMS_COMMON_API = null;
  let CMS_COMMON_FOOTER_API = null;
  let RECOMMENDATION_ENGINE_BASE_URL = null;
  let REDIRECT_URI = null;
  let INSTORE_ORDER_BASE_URL = null;
  let DYNAMIC_SEARCH_BASE_URL = null;
  let CMS_TOKEN_API = null;
  let SEARCH_TERM_BASE_API = null;
  let HOMECARE_SEARCH_API = null;
  let HOMECARE_BOOKING_API = null;
  let HOMECARE_CART_API = null;
  let HOMECARE_CAROUSEL_API = null;
  let CATEGORY_MENU_DATA_URL = null;
  let BLOB_DATA_BASE_URL = null;
  let AUTH_REALM = null;
  let GTM_ID = null;
  let SMART_LOOK_KEY = null;
  let HOST_COUNTRY = null;
  if (process.env.NEXT_PUBLIC_SENTRY_ENV !== 'PROD-F' && process.env.NEXT_PUBLIC_SENTRY_ENV !== 'PREPROD-F' && process.env.NEXT_PUBLIC_SENTRY_ENV !== 'PRODKSA-F') {
    const useEnvFile = process.env.NEXT_PUBLIC_SENTRY_ENV === 'development';
    const configData = !useEnvFile ? (0, _configHelper.getConfigData)() : null;
    WEBSITE_URL = useEnvFile ? process.env.NEXT_PUBLIC_WEBSITE_URL : (0, _configHelper.getConfigValue)(configData === null || configData === void 0 ? void 0 : configData.data, 'website_url') || '';
    CMS_ONBOARDING_API = process.env.NEXT_PUBLIC_CMS_ONBOARDING_API;
    HP_API_END_POINT = process.env.NEXT_PUBLIC_HP_API_END_POINT;
    API_END_POINT = useEnvFile ? process.env.NEXT_PUBLIC_API_END_POINT : (0, _configHelper.getConfigValue)(configData === null || configData === void 0 ? void 0 : configData.data, 'api_end_point') || '';
    NPS_API_END_POINT = useEnvFile ? process.env.NEXT_PUBLIC_NPS_API_END_POINT : (0, _configHelper.getConfigValue)(configData === null || configData === void 0 ? void 0 : configData.data, 'api_end_point') || '';
    ELASTIC_BASE_URL_V2 = useEnvFile ? process.env.NEXT_PUBLIC_ELASTIC_BASE_URL_V2 : (0, _configHelper.getConfigValue)(configData === null || configData === void 0 ? void 0 : configData.data, 'elastic_base_url_v2') || '';
    GOOGLE_GEOCODE_API_URL = useEnvFile ? process.env.NEXT_PUBLIC_GOOGLE_GEOCODE_API_URL : (0, _configHelper.getConfigValue)(configData === null || configData === void 0 ? void 0 : configData.data, 'google_geocode_api_url') || '';
    MAP_API_KEY = useEnvFile ? process.env.NEXT_PUBLIC_MAP_API_KEY : (0, _configHelper.getConfigValue)(configData === null || configData === void 0 ? void 0 : configData.data, 'map_api_key') || '';
    USER_AGENT = process.env.NEXT_PUBLIC_USER_AGENT;
    CMS_TOKEN_API = process.env.NEXT_PUBLIC_CMS_TOKEN_URL;
    HOMECARE_SEARCH_API = useEnvFile ? process.env.NEXT_PUBLIC_HOMECARE_SEARCH_API_URL : (0, _configHelper.getConfigValue)(configData === null || configData === void 0 ? void 0 : configData.data, 'homecare_search_url') || '';
    HOMECARE_BOOKING_API = useEnvFile ? process.env.NEXT_PUBLIC_HOMECARE_BOOKING_API_URL : (0, _configHelper.getConfigValue)(configData === null || configData === void 0 ? void 0 : configData.data, 'homecare_booking_url') || '';
    HOMECARE_CART_API = useEnvFile ? process.env.NEXT_PUBLIC_HOMECARE_CART_API_URL : (0, _configHelper.getConfigValue)(configData === null || configData === void 0 ? void 0 : configData.data, 'homecare_cart_url') || '';
    HOMECARE_CAROUSEL_API = useEnvFile ? process.env.NEXT_PUBLIC_HOMECARE_CAROUSEL_API_URL : (0, _configHelper.getConfigValue)(configData === null || configData === void 0 ? void 0 : configData.data, 'homecare_carousel_url') || '';
    CATEGORY_MENU_DATA_URL = process.env.NEXT_PUBLIC_CATEGORY_MENU_DATA_URL;
    SEARCH_SERVICE_BASE_URL = useEnvFile ? process.env.NEXT_PUBLIC_SEARCH_SERVICE_BASE_URL : (0, _configHelper.getConfigValue)(configData === null || configData === void 0 ? void 0 : configData.data, 'search_service_base_url') || '';
    SEARCH_SERVICE_AUTOSUGGEST_BASE_URL = useEnvFile ? process.env.NEXT_PUBLIC_SEARCH_SERVICE_AUTOSUGGEST_BASE_URL : (0, _configHelper.getConfigValue)(configData === null || configData === void 0 ? void 0 : configData.data, 'search_service_autosuggest_base_url') || '';
    CMS_COMMON_API = useEnvFile ? process.env.NEXT_PUBLIC_CMS_API_URL : (0, _configHelper.getConfigValue)(configData === null || configData === void 0 ? void 0 : configData.data, 'cms_common_api') || '';
    CMS_COMMON_FOOTER_API = useEnvFile ? process.env.NEXT_PUBLIC_CMS_COMMON_FOOTER_API : (0, _configHelper.getConfigValue)(configData === null || configData === void 0 ? void 0 : configData.data, 'cms_common_footer_api') || '';
    RECOMMENDATION_ENGINE_BASE_URL = useEnvFile ? process.env.NEXT_PUBLIC_RECOMMENDATION_ENGINE_BASE_URL : (0, _configHelper.getConfigValue)(configData === null || configData === void 0 ? void 0 : configData.data, 'recommendation_engine_base_url') || '';
    REDIRECT_URI = useEnvFile ? process.env.NEXT_PUBLIC_REDIRECT_URI : (0, _configHelper.getConfigValue)(configData === null || configData === void 0 ? void 0 : configData.data, 'redirect_uri') || '';
    INSTORE_ORDER_BASE_URL = useEnvFile ? process.env.NEXT_PUBLIC_INSTORE_ORDER_BASE_URL : (0, _configHelper.getConfigValue)(configData === null || configData === void 0 ? void 0 : configData.data, 'instore_order_base_url') || '';
    DYNAMIC_SEARCH_BASE_URL = useEnvFile ? process.env.NEXT_PUBLIC_DYNAMIC_SEARCH_BASE_URL : (0, _configHelper.getConfigValue)(configData === null || configData === void 0 ? void 0 : configData.data, 'dynamic_search_base_url') || '';
    SEARCH_TERM_BASE_API = process.env.SEARCH_TERM_API;
    BLOB_DATA_BASE_URL = process.env.NEXT_PUBLIC_CATEGORY_MENU_DATA_URL + '/';
    AUTH_REALM = useEnvFile ? process.env.NEXT_PUBLIC_AUTH_REALM : (0, _configHelper.getConfigValue)(configData === null || configData === void 0 ? void 0 : configData.data, 'auth_realm') || '';
    GTM_ID = useEnvFile ? process.env.NEXT_PUBLIC_GTMID : process.env.NEXT_PUBLIC_GTMID;
    SMART_LOOK_KEY = useEnvFile ? process.env.SMARTLOOK_API_KEY : (0, _configHelper.getConfigValue)(configData === null || configData === void 0 ? void 0 : configData.data, 'smart_look_key') || '';
    HOST_COUNTRY = useEnvFile ? process.env.HOST_COUNTRY : (0, _configHelper.getConfigValue)(configData === null || configData === void 0 ? void 0 : configData.data, 'host_country') || 'uae';
  } else {
    const data = _MainCacheManager.default.getInstance().getConfig();
    WEBSITE_URL = '';
    CMS_ONBOARDING_API = data === null || data === void 0 ? void 0 : data.cms_onboarding_api;
    HP_API_END_POINT = data === null || data === void 0 ? void 0 : data.hp_api_end_point;
    API_END_POINT = data === null || data === void 0 ? void 0 : data.api_end_point;
    NPS_API_END_POINT = data === null || data === void 0 ? void 0 : data.nps_api_end_point;
    ELASTIC_BASE_URL_V2 = data === null || data === void 0 ? void 0 : data.elastic_base_url_v2;
    GOOGLE_GEOCODE_API_URL = data === null || data === void 0 ? void 0 : data.google_geocode_api_url;
    MAP_API_KEY = data === null || data === void 0 ? void 0 : data.map_api_key;
    USER_AGENT = data === null || data === void 0 ? void 0 : data.user_agent;
    SEARCH_SERVICE_BASE_URL = data === null || data === void 0 ? void 0 : data.search_service_base_url;
    SEARCH_SERVICE_AUTOSUGGEST_BASE_URL = data === null || data === void 0 ? void 0 : data.search_service_autosuggest_base_url;
    CMS_COMMON_API = data === null || data === void 0 ? void 0 : data.cms_api_url;
    CMS_COMMON_FOOTER_API = data === null || data === void 0 ? void 0 : data.cms_common_footer_api;
    RECOMMENDATION_ENGINE_BASE_URL = data === null || data === void 0 ? void 0 : data.recommendation_engine_base_url;
    REDIRECT_URI = data === null || data === void 0 ? void 0 : data.redirect_uri;
    INSTORE_ORDER_BASE_URL = data === null || data === void 0 ? void 0 : data.instore_order_base_url;
    DYNAMIC_SEARCH_BASE_URL = data === null || data === void 0 ? void 0 : data.dynamic_search_base_ur;
    CMS_TOKEN_API = '';
    SEARCH_TERM_BASE_API = '';
    HOMECARE_SEARCH_API = data === null || data === void 0 ? void 0 : data.homecare_search_api_url;
    HOMECARE_BOOKING_API = data === null || data === void 0 ? void 0 : data.homecare_booking_api_url;
    HOMECARE_CART_API = data === null || data === void 0 ? void 0 : data.homecare_cart_api_url;
    HOMECARE_CAROUSEL_API = data === null || data === void 0 ? void 0 : data.homecare_carousel_api_url;
    CATEGORY_MENU_DATA_URL = data === null || data === void 0 ? void 0 : data.category_menu_data_url;
    BLOB_DATA_BASE_URL = (data === null || data === void 0 ? void 0 : data.storage_url) + '/';
    AUTH_REALM = data === null || data === void 0 ? void 0 : data.auth_realm;
    GTM_ID = data === null || data === void 0 ? void 0 : data.gtm_id;
    SMART_LOOK_KEY = data === null || data === void 0 ? void 0 : data.smart_look_api_key;
    HOST_COUNTRY = data === null || data === void 0 ? void 0 : data.host_country;
  }
  return {
    WEBSITE_URL,
    CMS_ONBOARDING_API,
    HP_API_END_POINT,
    API_END_POINT,
    NPS_API_END_POINT,
    ELASTIC_BASE_URL_V2,
    GOOGLE_GEOCODE_API_URL,
    MAP_API_KEY,
    USER_AGENT,
    SEARCH_SERVICE_BASE_URL,
    SEARCH_SERVICE_AUTOSUGGEST_BASE_URL,
    CMS_COMMON_API,
    CMS_COMMON_FOOTER_API,
    RECOMMENDATION_ENGINE_BASE_URL,
    REDIRECT_URI,
    INSTORE_ORDER_BASE_URL,
    DYNAMIC_SEARCH_BASE_URL,
    CMS_TOKEN_API,
    SEARCH_TERM_BASE_API,
    HOMECARE_SEARCH_API,
    HOMECARE_BOOKING_API,
    HOMECARE_CART_API,
    HOMECARE_CAROUSEL_API,
    CATEGORY_MENU_DATA_URL,
    BLOB_DATA_BASE_URL,
    AUTH_REALM,
    GTM_ID,
    SMART_LOOK_KEY,
    HOST_COUNTRY
  };
};
exports.webEnvConfig = webEnvConfig;